import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { appContext, loadAction } from '../../util/decorators';
//import loadDataSources from 'action/loadDataSources';
//import { loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';

import linkTag2Initializer from '../../util/linkTag2Initializer';
import config from '../../config';
import PageWithoutSidebarsTVguide from '../Page/PageWithoutSidebarsTVguide.jsx';
import TvGuideMeta from './TvGuideMeta';
import Article from 'component/ArticleFeed/Article';
//import viasportBackend from '../../service/viasportBackend';

import FeedContainerSimple from 'component/NewsFeed/FeedContainerSimple.jsx';

import FeedContainerTVguide from 'component/NewsFeed/FeedContainerTVguide.jsx';

import InfiniteScrollLoader from '../InfiniteScrollLoader';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall';

// the data source to lazy load new items from when infinity scrolling

const INFINITE_SCROLL_REQUEST_LIMIT = 48;
const $loadDataSources = args => {
  const slug = _.get(config, `TVGUIDE_ARTICLE_${args.country.toUpperCase()}`);
  return slug ? loadDataSources({
    dataSourceConfigs: {
      tvguideArticle: 'articleBySlug',
    },
    country: args.counrtry,
    routeParams: {
      slug,
    },
    
  }) : null;
};

const $loadTVguideArticlesDataSources = args => {
  return loadDataSources({
    ...args,
    dataSourceConfigs: {
      tvguideArticles: 'tvguideArticles'
    },
    limit: {
      tvguideArticles: INFINITE_SCROLL_REQUEST_LIMIT
    },
  });
};

const mapStateToProps = state => ({
  article: _.get(state, 'dataSources.tvguideArticle[0]'),
  tvguideArticles: _.get(state, 'dataSources.tvguideArticles'),
  dataSources: state.dataSources,
});

const mapDispatchToProps = dispatch => ({
  loadMoreRelatedArticles: (offset) => {
    return dispatch(loadDataSources({
      dataSourceConfigs: { tvguideArticles: 'tvguideArticles' },
      offset: { tvguideArticles: offset },
      limit: { tvguideArticles: INFINITE_SCROLL_REQUEST_LIMIT },
    }));
  },
});



@loadAction($loadDataSources, $loadTVguideArticlesDataSources)
@connect(mapStateToProps, mapDispatchToProps)
@linkTag2Initializer('tv-guide')
@appContext
export default class TvGuide extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      height: 'calc(100vh - 140px)',
    };
    this.currentArticleOffset = _.size(props.tvguideArticles) || INFINITE_SCROLL_REQUEST_LIMIT;
  }

  componentDidMount() {
    this.refs.iframe.contentWindow.addEventListener(
      'message',
      event => this.receiveMessage(event),
      false,
    );
  }

  receiveMessage(event) {
    if (event.origin !== window.location.origin) return;

    this.setState({
      height: event.data,
    });
  }

  loadMoreArticles() {
    const { loadMoreRelatedArticles } = this.props;

    const promise = loadMoreRelatedArticles(this.currentArticleOffset);

    this.currentArticleOffset += INFINITE_SCROLL_REQUEST_LIMIT;

    return promise;
  }



  render() {
    const { article, tvguideArticles } = this.props;
    //console.log(`tvguideArticles TV :  ` + tvguideArticles);
    
    const rows = _.chunk(tvguideArticles, 2);
    return (
      <PageWithoutSidebarsTVguide>
        <div className="tv-guide">
          <TvGuideMeta />

          {!_.isEmpty(article) &&
            <Article article={article} firstArticle autoplay inline />}

          <h2>
            {this.context.app.t('TvGuide.heading')}
          </h2>

          <iframe
            id="tvguide-iframe"
            ref="iframe"
            src="https://data.nentgroup.dk/tvguide"
            style={{
              width: '100%',
              height: this.state.height,
            }}
          />
        </div>

 	<div className="row">
        <div className="template-item col-md-12">
          <div className="popular-videos">
            <h3 className="popular-heading">Nyheder</h3>
            {
              _.map(rows, row =>
                <div key={_.map(row, 'id').join('')} className="row">
                  {
                    _.map(row, article =>
                      <div key={article.id} className="col-md-12 popular-item">
                        <FeedContainerSimple keepSideBySide contentContainer={article} />
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
      </PageWithoutSidebarsTVguide>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/TvGuide/TvGuide.jsx